import { useSignUpQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useSignUpQueryParams";
import { WebApiError } from "@faire/web-api--source/WebApiError";
import { trackEvent } from "@faire/web/common/trackEvent";
import { useCallback } from "react";

export const useTrackSignUpSubmission = () => {
  const { queryParams } = useSignUpQueryParams();

  const trackStart = useCallback(() => {
    trackEvent(`sign-up-page/submit-form/attempt/${queryParams.signUp}`);
  }, [queryParams.signUp]);

  const trackSuccess = useCallback(() => {
    trackEvent(`sign-up-page/submit-form/success/${queryParams.signUp}`);
  }, [queryParams.signUp]);

  const trackFailure = useCallback((error: unknown) => {
    let errorCode = "unknown";
    if (error instanceof WebApiError) {
      errorCode =
        error.responseData.service_error_code ??
        error.responseData.localized_message ??
        error.responseData.message ??
        errorCode;
    }
    trackEvent(`sign-up-page/submit-form/error/${errorCode}`);
  }, []);

  return {
    trackStart,
    trackSuccess,
    trackFailure,
  };
};
